import React from 'react';
import fileDownload from "js-file-download";
import {decode} from 'base64-arraybuffer'

import {powerBIBase, trainingReportID} from "../../../config/PowerBiReportConfig";
import {generateTrainingReport} from "../../../services/ReportService";
import { appBaseURL } from '../../../config/URLConfig';

export const TrainingReport = ({context, setSpinnerText, showToaster}) => {

    const handleViewReportClick = () => {
        window.open(`${powerBIBase}${trainingReportID}/ReportSection`);
    }

    const handleDownloadPDFClick = async () => {
        setSpinnerText("Generating training report...")
        const [data, error] = await generateTrainingReport(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                const {report} = data;
                const arrayBuffer = decode(report);
                fileDownload(arrayBuffer, "Training Report", "application/pdf");
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const handleDownloadExcelClick = () => {
        window.open(`${appBaseURL}/api/training-report?username=${context.username}`);
    }

    return (
        <div>
            <h2 className="report-header">Training Report</h2>
            <div className="report-button-container">
                <div className={"report-button"} onClick={handleViewReportClick}>
                    Training Report
                </div>
                <div className={"report-button"} onClick={handleDownloadPDFClick}>
                    Download PDF
                </div>
                <div className={"report-button"} onClick={handleDownloadExcelClick}>
                    Download Excel
                </div>
            </div>
        </div>
    );
}
